export default __webpack_public_path__ + "static/media/driving-time.e2c439ac.svg";